import { render } from "./InvestmentReceipt.vue?vue&type=template&id=485c78be"
import script from "./InvestmentReceipt.vue?vue&type=script&lang=js"
export * from "./InvestmentReceipt.vue?vue&type=script&lang=js"
script.render = render

export default script